import { useContext, useEffect, useState } from "react"
import Footer from "../../components/Footer/Footer"
import InfoTour from "./components/InfoTour/InfoTour"
import styles from "./Tournaments.module.css"
import SpinPage from "../../components/UI/Spin/Spin"
import ServerService from "../../service/ServerService"
import { Context } from "../.."
import ErrorComponent from "../../components/UI/Error/ErrorComponent"

function Tournaments({ non_footer }) {
    const { store } = useContext(Context)
    const [statusLoad, setStatusLoad] = useState(true)
    const [tournaments, setTournaments] = useState([])
    async function main() {
        try {
            const response = await ServerService.get_tournaments();
            console.log(response.data)
            if (response.data.status === 1) {
                setTournaments(response.data.data)
                setStatusLoad(false)


            }
            else {
                store.add_message(response.data.err, ErrorComponent)
            }
        }
        catch (e) {
            console.log(e)
        }
    }
    useEffect(() => {
        main()
    }, [])
    if (statusLoad) {
        return <SpinPage />
    }
    return (
        <>

            <div className={styles.main} style={{ minHeight: !non_footer && "100vh",marginTop:(!non_footer&&store.isPhone)&&"60px" }}>

                <div className={styles.containerTournaments}>
                    {tournaments.map(el =>
                        <InfoTour date_start={el.date_start} link={"/tournament/" + el.id} image={el.image} amount={el.amount} accept_description={el.accept_description} name={el.name} time={el.date_end} />
                    )
                    }
                </div>


            </div>
            {!non_footer && <Footer />}

        </>
    )
}
export default Tournaments